import TowerTransitionComponent from "./TowerTransitionComponent";
const SiteOverview = () => {
    return(
        <div>
            <TowerTransitionComponent siteoverview={true}/>
        </div>
    )
}

export default SiteOverview;